import { render, staticRenderFns } from "./PlanAddons.vue?vue&type=template&id=4e4e94e4&scoped=true&"
import script from "./PlanAddons.vue?vue&type=script&lang=js&"
export * from "./PlanAddons.vue?vue&type=script&lang=js&"
import style0 from "./PlanAddons.vue?vue&type=style&index=0&id=4e4e94e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4e94e4",
  null
  
)

export default component.exports